import { DATE_FORMAT_DEFAULT } from '@/constants';
import dateFormat from 'dateformat';

export const getFullDateFromISO = (date, schema = DATE_FORMAT_DEFAULT) => {
  if (!date) {
    return '';
  }

  return dateFormat(new Date(date), schema);
};
